import React, { useImperativeHandle, useRef } from "react";
import { Input as InputLib, InputRef } from "@npm_leadtech/qr-ui-components";

import { InputAdapterProps } from "./types";

import { useAdapterLogic } from "./hooks";

export const InputAdapter = React.forwardRef<InputRef, InputAdapterProps>((props, ref) => {
  const internalRef = useRef<InputRef>(null);

  useImperativeHandle(ref, () => internalRef.current as InputRef, []);

  const inputProps = useAdapterLogic(props, internalRef);

  return <InputLib {...inputProps} />;
});

InputAdapter.displayName = "InputAdapter";
